import { INodeFromBack } from "@/types";

export default class Node implements INodeFromBack {

    public id: number;
    public name: string;
    public type: 'file' | 'folder';
    public mime_type: string;
    public size: number;
    public parent: number | null;
    public color: string;
    public created_at: number;
    public updated_at: number;
    public deleted_at: number | null;
    public user_creator: number;
    public user_updated: number;
    public user_deleted: number | null;

    constructor(node: INodeFromBack) {
        this.id = node.id;
        this.name = node.name;
        this.type = node.type;
        this.mime_type = node.mime_type;
        this.size = node.size;
        this.parent = node.parent;
        this.color = node.color;
        this.created_at = node.created_at;
        this.updated_at = node.updated_at;
        this.deleted_at = node.deleted_at;
        this.user_creator = node.user_creator;
        this.user_updated = node.user_updated;
        this.user_deleted = node.user_deleted;
    }

}